import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/mock';
import useReveal from '../hooks/useReveal';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const [headRef, headVisible] = useReveal();
  const [listRef, listVisible] = useReveal();

  return (
    <section className="bg-[#F5EDDD] py-24 md:py-32 grain">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div ref={headRef} className={`reveal ${headVisible ? 'in' : ''} lg:col-span-4`}>
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#A07A4F] mb-5">
            — Questions, answered
          </p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl text-[#33200F] leading-[1.05] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            The bits people
            <br />
            <span className="italic text-[#5B3A24]">tend to ask.</span>
          </h2>
          <p className="text-[#5B3A24] text-[14px] leading-[1.85] max-w-sm">
            Still curious? Drop us a line at <span className="text-[#33200F]">info@timberandthread.com.au</span> and a human will reply, usually within a day.
          </p>
        </div>

        <div ref={listRef} className={`reveal reveal-delay-1 ${listVisible ? 'in' : ''} lg:col-span-8`}>
          <ul className="border-t border-[#C9B596]">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <li key={i} className="border-b border-[#C9B596]">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full py-6 flex items-center justify-between gap-6 text-left group"
                  >
                    <span
                      className="text-xl md:text-2xl text-[#33200F] transition-colors group-hover:text-[#5B3A24]"
                      style={{ fontFamily: "'Cormorant Garamond', serif" }}
                    >
                      {f.q}
                    </span>
                    <span
                      className={`shrink-0 h-9 w-9 rounded-full border flex items-center justify-center transition-colors ${
                        isOpen
                          ? 'border-[#33200F] bg-[#33200F] text-[#F5EDDD]'
                          : 'border-[#C9B596] text-[#33200F] group-hover:border-[#33200F]'
                      }`}
                    >
                      {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                    </span>
                  </button>
                  <div
                    className="grid transition-[grid-template-rows] duration-500 ease-out"
                    style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                  >
                    <div className="overflow-hidden">
                      <p className="pb-7 pr-12 text-[15px] text-[#5B3A24] leading-[1.9]">{f.a}</p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
